import React, { Fragment } from 'react'
import Richtext from '../atoms/Richtext'
import Image from '../atoms/Image'
import SbEditable from 'storyblok-react'

const ProductIntroBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="product-intro-block">
        <div className="product-intro-block-wrapper">
          <div className="product-intro-block-container">
            <div className="product-intro-block-row">
              {block.product_image_hidden !== true && (
                <div className="product-intro-block-image">
                  {block.main_award?.length > 0 && (
                    <div
                      className={`product-intro-block-main-award ${
                        block.hero_mirrored ? 'hero-mirrored' : ''
                      }`}
                    >
                      <div className="product-intro-block-main-award-wrapper">
                        {block.main_award?.length > 0 &&
                          block.main_award.map((item, index) => (
                            <div
                              className="product-intro-block-main-award-content"
                              style={{
                                backgroundImage:
                                  'url(' + item.preview_url + ')',
                                height: '100%',
                              }}
                              key={index}
                            />
                          ))}
                      </div>
                    </div>
                  )}
                  <Image
                    data-rellax-center={true}
                    data-rellax-speed={-1}
                    className="img-fluid"
                    image={block.image}
                    alt={block.alt}
                  />
                </div>
              )}

              <div className="product-intro-block-intro">
                <div
                  className="product-intro-block-intro-wrapper"
                  data-rellax-center={true}
                  data-rellax-speed={2}
                >
                  <div className="product-intro-block-intro-container">
                    {block.name?.length > 0 && (
                      <p className="h1">{block.name}</p>
                    )}
                    {block.headline?.length > 0 && <h2>{block.headline}</h2>}
                    {block.intro?.length > 0 && <Richtext text={block.intro} />}
                  </div>

                  {block.awards?.length > 0 && (
                    <div className="product-intro-block-awards">
                      {block.awards.map((item, index) => (
                        <div className="product-intro-block-awards-item">
                          <img src={item.preview_url} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="product-intro-block-highlight">
                <div
                  className="product-intro-block-highlight-wrapper"
                  data-rellax-center="true"
                  data-rellax-speed={2}
                >
                  {block.highlight_text?.length > 0 && (
                    <Richtext text={block.highlight_text} />
                  )}
                </div>
              </div>
              <div className="product-intro-block-main">
                <div
                  className="product-intro-block-main-wrapper"
                  data-rellax-center="true"
                  data-rellax-speed={1}
                >
                  {block.main_text?.length > 0 && (
                    <Richtext text={block.main_text} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ProductIntroBlock
